import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { BsCheck } from 'react-icons/bs';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { themeColors } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import { BlsButton } from "./ui-common";
import { useNavigate } from "react-router-dom";
import ParameterConstants from '../constants/ParameterConstants';

const ThemeSettings = () => {
    const { setMode, currentMode, setThemeSettings } = useStateContext();
    const navigate = useNavigate();

    const logout = () => {
        sessionStorage.removeItem('userInfo');
        sessionStorage.removeItem('userName');
        navigate(ParameterConstants.URL_EXTENSION + '/Login');
    }

    const goToPasswordChangePage = () => {
        navigate(ParameterConstants.URL_EXTENSION + '/ChangePassword');
    }

    return (
        <>
            <div className="fixed right-0 top-0 nav-item h-full dark:text-gray-200 bg-white dark:bg-[#484B52] w-400 ">
                <div className="flex justify-between items-center p-4 ml-4">
                    <p className="font-semibold text-lg">Ayarlar</p>
                    <button
                        type="button"
                        onClick={() => setThemeSettings(false)}
                        style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
                        className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
                    >
                        <MdOutlineCancel />
                    </button>

                </div>
                <div className="flex-col border-t-1 border-color p-4 ml-4">
                    <p className="font-semibold text-xl ">Tema Ayarları</p>

                    <div className="mt-4">
                        <input
                            type="radio"
                            id="light"
                            name="theme"
                            value="Light"
                            className="cursor-pointer"
                            onChange={setMode}
                            checked={currentMode === 'Light'}
                        />
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label htmlFor="light" className="ml-2 text-md cursor-pointer">
                            Açık
                        </label>
                    </div>
                    <div className="mt-2">
                        <input
                            type="radio"
                            id="dark"
                            name="theme"
                            value="Dark"
                            onChange={setMode}
                            className="cursor-pointer"
                            checked={currentMode === 'Dark'}
                        />
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label htmlFor="dark" className="ml-2 text-md cursor-pointer">
                            Karanlık
                        </label>
                    </div>
                </div>
                <div className="flex-col border-t-1 border-color p-4 ml-4">
                    <p className="font-semibold text-xl ">Şifre</p>
                    <div className="mt-4">
                        <BlsButton type="update" onClick={goToPasswordChangePage} buttonStyle={{ width: "50%" }}>Şifre Değiştir</BlsButton>
                    </div>
                </div>
                <div className="flex-col border-t-1 border-color p-4 ml-4">
                    <p className="font-semibold text-xl ">Çıkış</p>
                    <div className="mt-4">
                        <BlsButton type="cancel" onClick={logout} buttonStyle={{ width: "50%" }}>Çıkış Yap</BlsButton>
                    </div>
                </div>

            </div>
            <div className="bg-half-transparent w-full h-full fixed top-0 right-0 z-30" onClick={() => setThemeSettings(false)} />
        </>
    );
};

export default ThemeSettings;
